import React from 'react';
import ReactDOM from 'react-dom';
import './style.scss';
import App from './App';
import WebFont from 'webfontloader';
import registerServiceWorker from './registerServiceWorker';

WebFont.load({
  google: {
    families: [ 'Open Sans:300,600,700:latin-ext', 'Inconsolata:400:latin-ext']
  }
});

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js